import { render, staticRenderFns } from "./BancoDocumento.vue?vue&type=template&id=90134762"
import script from "./BancoDocumento.vue?vue&type=script&lang=js"
export * from "./BancoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports